import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { TranslocoModule } from '@ngneat/transloco';

import { ComponentsModule } from '@core/components/components.module';
import { SharedModule } from '@core/shared.module';

import { ShipmentEffects } from '@shipment/state';

import { SupplierLookupDialogGridComponent } from './supplier-lookup-dialog/grid/grid.component';
import { SupplierLookupDialogComponent } from './supplier-lookup-dialog/supplier-lookup-dialog.component';

@NgModule({
  declarations: [SupplierLookupDialogComponent, SupplierLookupDialogGridComponent],
  imports: [CommonModule, SharedModule, ComponentsModule, TranslocoModule, EffectsModule.forFeature([ShipmentEffects])],
  exports: [SupplierLookupDialogComponent],
})
export class ShipmentModule {}
